import React from 'react';
import {pathEq} from 'ramda';
import {JsonAdSummary} from '../../ext/lib/types';
import {APIError, UnsafeAPIResponse} from '../../hooks/useApi';
import ProgramAdActions from './ProgramAdActions';
import {User} from '../common/UserContext';
import adSummaryList from './AdSummaryList';
import useApi from '../../hooks/useApi';

type Props = {user: User; apiToken: string};

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
const ProgramAdsList: React.FC<any> = adSummaryList(ProgramAdActions);

export const ProgramAds: React.FC<Props> = ({user, apiToken}) => {
  const unsafeAds: UnsafeAPIResponse<JsonAdSummary[]> = useApi(apiToken, '/api/v1/requests/program');
  if (pathEq(['@@type'], 'Error', unsafeAds)) {
    console.error((unsafeAds as APIError).message);
    return <div className="alert error">An error occurred while fetching ads. Try again or contact support</div>;
  } else {
    return <ProgramAdsList
      user={user}
      ads={unsafeAds}
      emptyMessage="All ads have been programmed."
      flagUnpaid={true}
    />;
  }
};
